const LOCAL_STORAGE_KEY = {
  empower: {
    TOKEN: "udf_token",
    USER_PHOTO: ""
  },
  myempower: {
    TOKEN: "myudf_token",
    USER_PHOTO: "_photo_"
  }
};
const SESSION_STORAGE_KEY = {
  originalUrl: "original_url",
  originalUrlType: "original_url_type",
  loginAutoRedirect: "login_auto_redirect"
};
const API_ENDPOINTS = {
  empower: {
    refreshToken: "/udfadmin/auth-udf/refreshtoken",
    me: "/udfadmin/login/users/me",
    feature: "/udfadmin/mgmt/masters/features",
    userPermission: "/udfadmin/login/users/userpermission",
    domains: "/udfadmin/login/users/domains",
    featureAccess: "/udfadmin/mgmt/masters/access",
    verifyUnmaskingOtp: "/udfadmin/login/users/verify",
    sendUnmaskingOtp: "/udfadmin/login/users/send"
  },
  myempower: {
    refreshToken: "/myempadmin/auth-myemp/refreshtoken",
    me: "/myempadmin/login/users/me",
    feature: "/myempadmin/myemp/masters/features",
    userPermission: "/myempadmin/login/users/userpermission"
  }
};
const LOGIN_URL = {
  empower: "/login",
  myempower: "/"
};
const DEFAULT_MENUS_URL = "/menus.json";
const DEFAULT_PUBLIC_MENUS_URL = "/public-menus.json";
const DEFAULT_ESHOP_BRNS_URL = "/eshop-brnlist.json";
const DEFAULT_HEADER_LOGO_URL = "/images/singtel-logo-white.svg";
const DEFAULT_FOOTER_LOGO_URL = "/images/empower_logo_landscape.png";
const DEFAULT_APP_NAME = "Empower Portal";
const NOTIFIER_UNAUTHORIZED_TITLE = "Oops! You don\u2019t have permission";
const NOTIFIER_UNAUTHORIZED_MESSAGE = "Looks like you do not have permission to process the operation due to permission policies set by your admin manager. Please contact your admin manager to gain the required access.";
const NOTIFIER_UNAUTHORIZED_BUTTON_TEXT = "Ok, got it!";
const HEADER_SOURCE = "SOURCE";
const HEADER_SOURCE_MYEMPOWER = "MYEMPOWER";
const AM_STORAGE_KEY = {
  IS_AM_USER: "is_am_user",
  AM_INFO: "am_info"
};
const CACHE_GET_STORAGE = "getSessionStorage";
const CACHE_SET_STORAGE = "setSessionStorage";
const MASK_TOKEN_NAME = "MASK_TOKEN";
const MASK_CURRENT_MODULE = "MASK_CURRENT_MODULE";
const MASK_LEFT_TIME = "MASK_LEFT_TIME";
const VERIFY_OTP_FAILED_BLOCKED = "VERIFY_OTP_FAILED_BLOCKED";
const MASKING_MAX_TRIES_ERROR_EXPIRE_SECONDS = 180;
export { AM_STORAGE_KEY, API_ENDPOINTS, CACHE_GET_STORAGE, CACHE_SET_STORAGE, DEFAULT_APP_NAME, DEFAULT_ESHOP_BRNS_URL, DEFAULT_FOOTER_LOGO_URL, DEFAULT_HEADER_LOGO_URL, DEFAULT_MENUS_URL, DEFAULT_PUBLIC_MENUS_URL, HEADER_SOURCE, HEADER_SOURCE_MYEMPOWER, LOCAL_STORAGE_KEY, LOGIN_URL, MASKING_MAX_TRIES_ERROR_EXPIRE_SECONDS, MASK_CURRENT_MODULE, MASK_LEFT_TIME, MASK_TOKEN_NAME, NOTIFIER_UNAUTHORIZED_BUTTON_TEXT, NOTIFIER_UNAUTHORIZED_MESSAGE, NOTIFIER_UNAUTHORIZED_TITLE, SESSION_STORAGE_KEY, VERIFY_OTP_FAILED_BLOCKED };